import tv, { SchemaType, string } from "typed-object-validator";
import { Test, User, Registration } from ".";

export function removeFullEventLocations(e: Event) {
    let now = new Date().getTime();
    e.locations = e
        .locations!.map((location) => ({
            ...location,
            timestamps: location.timestamps!.filter((timestamp) => timestamp.timeStamp > now && timestamp.reservationCount < location.limit),
        }))
        .filter((location) => location.timestamps!.length > 0);
}

export const PartialEventTimeStampSchema = tv.object({
    id: tv.number().optional(),
    timeStamp: tv.number(),
});
export type PartialEventTimeStamp = SchemaType<typeof PartialEventTimeStampSchema>;

export class EventTimeStamp {
    id?: number;
    timeStamp: number;
    reservationCount: number;
    reservations?: EventReservation[];
    location?: EventLocation;
    locationId: number;
    event?: Event;
    eventId: string;

    constructor(locationId: number, timeStamp: number, eventId: string) {
        this.timeStamp = timeStamp;
        this.reservationCount = 0;
        this.locationId = locationId;
        this.eventId = eventId;
    }
}

export const PartialEventLocationSchema = tv.object({
    id: tv.number().optional(),
    address: tv.string().min(1, "Geef een adres in.").max(100, "Gebruik een kortere notatie."),
    limit: tv.number().min(1, "Geef een limiet in."),
    timestamps: tv.array(PartialEventTimeStampSchema),
});
export type PartialEventLocation = SchemaType<typeof PartialEventLocationSchema>;

export class EventLocation {
    id?: number;
    eventId?: string;
    /**
     * @v-min 1 Geef een adres in.
     * @v-max 100 Gebruik een kortere notatie.
     */
    address: string;
    /**
     * @v-min 1 Geef een limiet in.
     */
    limit: number;
    timestamps?: EventTimeStamp[];
    event?: Event;

    constructor(address: string, limit: number) {
        this.address = address;
        this.limit = limit;
        this.timestamps = [];
    }
}

export const PartialEventSchema = tv.object({
    id: tv.string(),
    title: tv.string().min(1, "Voer een event naam in.").max(100, "Te lang."),
    description: tv.string().max(1000, "Te lang."),
    locations: tv.array(PartialEventLocationSchema),
});
export type PartialEvent = SchemaType<typeof PartialEventSchema>;

export interface Event {
    id: string;
    /**
     * @v-min 1 Voer een event naam in.
     * @v-max 100 Deze event naam is te lang
     */
    title: string;
    /**
     * @v-max 1000 Deze beschrijving is te lang
     */
    description: string;
    testId?: number;
    test?: Test;
    locations?: EventLocation[];
    reservations?: EventReservation[];
    createdTimeStamp: number;
    notifiedUsers: boolean;
}

export interface EventReservation {
    id?: number;
    eventId: string;
    event?: Event;
    userId: number;
    user?: User;
    registrationUserId?: number;
    registrationTestId?: number;
    registration?: Registration;
    timestampId?: number;
    timestamp?: EventTimeStamp;
    present: boolean;
    createdTimeStamp: number;
}
